import { createBrowserHistory } from 'history';

// For Auth0 to redirect back to the app
export const history = createBrowserHistory();
